import { render } from "./ClassCard.vue?vue&type=template&id=a1de3976&scoped=true&ts=true"
import script from "./ClassCard.vue?vue&type=script&lang=ts"
export * from "./ClassCard.vue?vue&type=script&lang=ts"

import "./ClassCard.vue?vue&type=style&index=0&id=a1de3976&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1de3976"]])

export default __exports__